var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('DynamicList',{ref:"dynamicCardList",attrs:{"searchFormStructure":_vm.dataSearchFormStructure,"columns":_vm.dataColumns,"edit":_vm.dataEdit,"onRetrieve":_vm.onRetrieve,"root":"/report/event-visits","searchArgs":_vm.searchArgs}},[_vm._t("default",[_c('b-button',{staticClass:"mb-3",attrs:{"variant":"light"},on:{"click":function($event){_vm.$refs.modalExport.open = true}}},[_vm._v("\n                "+_vm._s(_vm.Core.Definition.getDefinition("Exporter sous format ..."))+"\n            ")]),_c('ModalExport',{ref:"modalExport",attrs:{"root":"/report/event-visits","formStructure":{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportFormat'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                 {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'exportTitle'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'userFirstname'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'userLastname'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'userPhone'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'userEmail'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'visitCount'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'presentCount'
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'absenceCount'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'visitLastDate'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'exportFormat',
                                    type: 'select',
                                    options: _vm.Core.Export.formatOptions(),
                                    label: _vm.Core.Definition.getDefinition('Format'),
                                    value: null,
                                    onSelect: function() {}
                                },
                                {
                                    id: 'exportTitle',
                                    type: 'text',
                                    label: _vm.Core.Definition.getDefinition('Titre'),
                                    value: '',
                                    required: true
                                },
                                {
                                    id: 'userFirstname',
                                    type: 'checkbox',
                                    labelCols: 6,
                                    label: _vm.Core.Definition.getDefinition('Prénom'),
                                    value: true,
                                     export: 'userFirstname',
                                    onChange: function() {}
                                },
                                {
                                    id: 'userLastname',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Nom de famille'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'userLastname',
                                    onChange: function() {}
                                },
                                {
                                    id: 'userPhone',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Téléphone'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'userPhone',
                                    onChange: function() {}
                                },
                                {
                                    id: 'userEmail',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Courriel'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'userEmail',
                                    onChange: function() {}
                                },
                                {
                                    id: 'visitCount',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Nombre de visites'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'visitCount',
                                    onChange: function() {}
                                },
                                {
                                    id: 'presentCount',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Nombre de présences'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'presentCount',
                                    onChange: function() {}
                                },
                                {
                                    id: 'absenceCount',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Nombre d\'absences'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'absenceCount',
                                    onChange: function() {}
                                },
                                {
                                    id: 'visitLastDate',
                                    type: 'checkbox',
                                    label: _vm.Core.Definition.getDefinition('Dernière visite'),
                                    value: true,
                                    labelCols: 6,
                                     export: 'visitLastDate',
                                    onChange: function() {}
                                }
                            ]}},on:{"onSubmit":_vm.onExport}})],{"slot":"afterSearchForm"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }